// extracted by mini-css-extract-plugin
export default {"productcomp":"ProductComp_productcomp__a68aK","filtercomp":"ProductComp_filtercomp__iDe31","productlist":"ProductComp_productlist__uHKMH"};